// extracted by mini-css-extract-plugin
export default {"root":"StudyProgress_root__jJL7-","label":"StudyProgress_label__D+LYM"};